import { render, staticRenderFns } from "./BothIcon.vue?vue&type=template&id=244a8c4c&scoped=true"
import script from "./BothIcon.vue?vue&type=script&lang=js"
export * from "./BothIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a8c4c",
  null
  
)

export default component.exports